import React, { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Grid, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useSample } from "../../utils/useSample";
import {
  useSamplingProcedure,
  useUser,
} from "@services/servicesGenericsTables";
import {
  MAutocomplete,
  MDatePicker,
  ResponsiveFormContainer,
} from "@app/components";
import { yesNoTable } from "@app/utils/tables/shared.tables";
import ErrorMessage from "@app/utils/ErrorMessage";
import dayjs from "dayjs";

const Management = () => {
  const form = useFormContext();
  const { idMuestra } = useParams();
  const { get, stateSample } = useSample();
  const { userList } = useUser();
  const { procedureList } = useSamplingProcedure();

  const sample = get(Number(idMuestra));
  const currentType = sample?.sample_type?.codigo;

  const filterSamplingProcedureList = useMemo(() => {
    return procedureList.filter(
      (item) => item.codigo === currentType && item.codop === "REC"
    );
  }, [procedureList, currentType]);

  useEffect(() => {
    if (filterSamplingProcedureList.length > 0) {
      form.setValue("malpma_procedure", filterSamplingProcedureList[0]);
    }
  }, [filterSamplingProcedureList, form]);

  const reservation = form.watch("reservation");

  useEffect(() => {
    if (reservation.label === "N") {
      const analystValue = form.getValues("analyst");
      const matchingUser = userList.find(
        (user) => user.username === analystValue?.username
      );

      if (!form.getValues("retirement_analyst") && matchingUser) {
        form.setValue("retirement_analyst", matchingUser);
      }

      if (!form.getValues("retirement_date")) {
        const today = dayjs();
        form.setValue("retirement_date", today);
      }

      form.clearErrors(["retirement_analyst", "retirement_date"]);
    }
  }, [reservation]);

  return (
    <>
      {stateSample.sampling.isSave ? (
        <>
          <ResponsiveFormContainer columns={5}>
            <MAutocomplete
              key={JSON.stringify(form.getValues("reservation"))}
              name="reservation"
              options={yesNoTable}
              label="Seleccione reserva"
              getOptionLabel={(option) => option.label || ""}
              validation={{ required: "La reserva es requerida" }}
            />
          </ResponsiveFormContainer>
          <Grid item xs={12} my={2}>
            <Typography variant="tagText">{"Recepción"}</Typography>
          </Grid>
          <ResponsiveFormContainer columns={5}>
            <MAutocomplete
              key={JSON.stringify(form.getValues("reception_analyst"))}
              name="reception_analyst"
              options={userList}
              label="Seleccione un analista de recepción"
              getOptionLabel={(option) => option.username || ""}
              validation={{ required: "El analista de recepción es requerido" }}
            />
            <MDatePicker
              name="date_start_reception"
              pickerType="datetime"
              label="Fecha y hora Recepción"
              validation={{
                required: "La fecha y hora de inicio de recepción es requerida",
              }}
            />
            <MAutocomplete
              key={JSON.stringify(form.getValues("malpma_procedure"))}
              name="malpma_procedure"
              options={filterSamplingProcedureList}
              label="Procedimiento MLPMA"
              getOptionLabel={(option) => `${option.numop}` || ""}
              validation={{
                required:
                  filterSamplingProcedureList.length > 0
                    ? "El procedimiento MLPMA es requerido"
                    : false,
              }}
            />
          </ResponsiveFormContainer>

          {form.watch("reservation") && !form.watch("reservation")?.id && (
            <>
              <Grid item xs={12} my={2}>
                <Typography variant="tagText">{"Retirada"}</Typography>
              </Grid>
              <ResponsiveFormContainer columns={5}>
                <MAutocomplete
                  key={JSON.stringify(form.getValues("retirement_analyst"))}
                  name="retirement_analyst"
                  options={userList}
                  label="Seleccione un analista de retirada"
                  getOptionLabel={(option) => option.username || ""}
                  validation={{
                    required: "El analista de retirada es requerido",
                  }}
                />
                <MDatePicker
                  name="retirement_date"
                  pickerType="datetime"
                  label="Fecha y hora Inicio Retirada"
                  validation={{
                    required:
                      "La fecha y hora de inicio de retirada es requerida",
                  }}
                />
              </ResponsiveFormContainer>
            </>
          )}
        </>
      ) : (
        <ErrorMessage />
      )}
    </>
  );
};

export default Management;
